export default interface Role {
  id: number;
  name: string;
  description: string;
  updatedAt: Date;
  createdAt: Date;
}

export enum RoleId {
  SuperAdmin = 1,
  Admin = 2,
  EntityOficial = 3,
  Publisher = 4,
  Citizen = 5,
  PublicRelation = 6,
}
